// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__X4cIH","row":"ProcedureTreatmentSummary_row__2Rkk2"};